var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-button",class:{ active: _vm.isActive },on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"icon-container"},[_c('img',{attrs:{"src":_vm.iconSrc,"alt":_vm.text}})]),_c('div',{staticClass:"button-text",class:{ 'light-text': _vm.isLight }},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }